import { render } from "./Inicio.vue?vue&type=template&id=3ca2351e"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"
script.render = render

export default script